module.exports = __webpack_public_path__ + "img/1518102494.6cf9fef2.jpg";